import { Person, RestaurantOutlined } from "@mui/icons-material";
import { Box, Typography, Rating } from "@mui/material";
import TimezoneChip from "components/TimezoneChip";
import { IReviewModel } from "../models";

function ReviewCard(props: IReviewModel) {
  return (
    <Box my={1}>
      <Box display="flex" alignItems="center">
        <Box display="flex" alignItems="center" flex={1} py={1}>
          <Person sx={{ marginRight: 1 }} />
          <Typography
            textAlign="center"
            sx={{
              P: {
                marginBottom: 0,
                paddingBottom: 0,
              },
            }}
          >
            {props.reviewerName}
          </Typography>
          <Box display="flex" alignItems="start" mx={1} p={1}>
            <Rating size="small" value={props.rating.avg} readOnly sx={{ mx: 1 }} />
            <Typography fontWeight="bold">{props.rating.avg}</Typography>
          </Box>
        </Box>

        <Box display="flex" alignItems="center">
          <TimezoneChip value={props.reviewedPlan.timeZone} />
          <Typography
            px={2}
            marginLeft={1}
            sx={{
              bgcolor: "gray",
              color: "white",
              width: "max-content",
              borderRadius: 2,
            }}
          >
            {props.usageScene}
          </Typography>
        </Box>
      </Box>

      <Box display="flex" alignItems="center">
        <Box display="flex" flex={1} p={1}>
          <Box display="flex" alignItems="center" px={1} borderRight={1}>
            <Typography>料理・味</Typography>
            <Typography fontWeight="bold" sx={{ mx: 1 }}>
              {props.rating.cooking}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" px={1} borderRight={1}>
            <Typography>雰囲気</Typography>
            <Typography fontWeight="bold" sx={{ mx: 1 }}>
              {props.rating.atmosphere}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" px={1} borderRight={1}>
            <Typography>接客・サービス</Typography>
            <Typography fontWeight="bold" sx={{ mx: 1 }}>
              {props.rating.service}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" px={1}>
            <Typography>コストパフォーマンス</Typography>
            <Typography fontWeight="bold" sx={{ mx: 1 }}>
              {props.rating.cost}
            </Typography>
          </Box>
        </Box>

        <Typography >{props.date}</Typography>
      </Box>

      <Box display="flex" p={2} flexDirection="column" bgcolor="#eee">
        <Box display="flex" flex={1}>
          {props.reviewContent}
        </Box>

        <Box
          display="flex"
          alignItems="start"
          justifyContent="end"
          color="#af9b65"
          paddingTop={1}
        >
          <RestaurantOutlined fontSize="small" sx={{mx: 1}} />
          <Typography fontSize="small">{props.reviewedPlan.highlightedName}</Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default ReviewCard;
